import { ApiError } from "./api-error";

const username = process.env.NEXT_PUBLIC_API_KEY_USER;
const password = process.env.NEXT_PUBLIC_API_KEY_PASSWORD;
const token = btoa(`${username}:${password}`);



const getBaseUrl = () => {
  if (typeof window === "undefined") {
    return process.env.BASE_URL;
  }
  return process.env.NEXT_PUBLIC_BASE_URL;
};

const getAuthHeaders = (options = {}) => {
  if (!token) throw new ApiError(401, "Token missing");

  const headers = {
    Authorization: `Basic ${token}`,
  };

  if (
    !options.isFormData &&
    !(options.body instanceof FormData)
  ) {
    headers["Content-Type"] = "application/json";
  }

  return headers;
};


export const apiFetch = async (path, options = {}) => {
  const baseUrl = getBaseUrl();
  if (!baseUrl) {
    throw new ApiError(500, "Base URL not configured");
  }

  const res = await fetch(`${baseUrl}${path}`, {
    ...options,
    headers: {
      ...getAuthHeaders(options),
      ...options.headers, // allow override
    },
  });

  let data = null;
  try {
    data = await res.json();
  } catch {}

  if (!res.ok) {
    throw new ApiError(
      res.status,
      data?.message || "Internal server error"
    );
  }

  return data;
};
